import {EventEmitter} from 'eventemitter3'

export const tableToolBarEvent = new EventEmitter()

export const tableToolBarEventTypes = {
    ON_ITEM_SELECTED: 'ON_ITEM_SELECTED',
}

export function getTableToolBarEventKey(tableKey, eventType) {
    if (!tableKey) {
        return ''
    }

    switch (eventType) {
        case tableToolBarEventTypes.ON_ITEM_SELECTED:
            return `ON_ITEM_SELECTED_${tableKey}`

        default:
            return ''
    }
}

export function onItemTableToolBarSelectedListener(
    tableKey,
    eventType = tableToolBarEventTypes.ON_ITEM_SELECTED,
    selectedItem,
) {
    if (!tableKey) {
        return
    }

    tableToolBarEvent.emit(
        `${getTableToolBarEventKey(tableKey, eventType)}`,
        selectedItem,
    )
}

export function removeItemSelectedListener(tableKey, eventType) {
    if (!tableKey) {
        return
    }

    tableToolBarEvent.removeAllListeners(
        getTableToolBarEventKey(tableKey, eventType),
    )
}
